import type { RouteRecordRaw } from 'vue-router'

import { AdokLayout as Layout } from '@/apps/adok/app/layout'
import { routeParam } from '@/apps/adok/shared/lib'

const AdnetworksPage = () =>
  import('@/apps/adok/pages/adnetworks').then((m) => m.AdnetworksPage)
const AdnetworksOnboardingPage = () =>
  import('@/apps/adok/pages/adnetworks-onboarding').then(
    (m) => m.AdnetworksOnboardingPage
  )

/**
 * The paths are the legacy ones verbatim — bookmarks and the links the legacy creative
 * rows still print land on them, so they cannot be renamed.
 *
 * The only route file annotated `RouteRecordRaw[]`, because it is the only one holding a
 * `redirect` callback: the annotation is what types `to` for it. Its siblings are plain
 * records and are checked where `app/router.ts` spreads them into its own annotated array.
 */
const rotationRoutes: RouteRecordRaw[] = [
  {
    path: '/advertising/rotation',
    component: Layout,
    children: [
      {
        path: '',
        name: 'rotation',
        component: AdnetworksPage,
        meta: { title: 'Rotation' }
      },
      {
        path: 'ask',
        name: 'rotation-ask',
        component: AdnetworksPage,
        meta: { title: 'Request a new ad network', hidden: true }
      },
      {
        path: 'spots/:cid',
        name: 'rotation-spots',
        component: AdnetworksPage,
        meta: { title: 'Choose spots', hidden: true }
      },
      {
        path: 'blockers/:cid/list',
        name: 'rotation-blockers',
        component: AdnetworksPage,
        meta: { title: 'Configure blocked traffic sources', hidden: true }
      },
      {
        path: 'blockers/:cid/new',
        name: 'rotation-blocker-new',
        component: AdnetworksPage,
        meta: { title: 'Block traffic on creative', hidden: true }
      },
      {
        path: ':sourceId/link',
        name: 'rotation-link',
        component: AdnetworksPage,
        meta: { title: 'Link the network', hidden: true }
      },
      {
        path: ':sourceId/import',
        name: 'rotation-import',
        component: AdnetworksPage,
        meta: { title: 'Import zones', hidden: true }
      }
    ]
  },
  {
    path: '/advertising/rotation/creatives',
    component: Layout,
    children: [
      {
        path: ':source/new-creative',
        name: 'creatives-new',
        component: AdnetworksPage,
        meta: { title: 'New Creative', hidden: true }
      },
      // No caller left in the app; kept so URLs already out there still land.
      {
        path: ':spotId/new-spot-creative/:typeId/:stream/:topic/:sizeId?',
        name: 'creatives-new-from-spot',
        component: AdnetworksPage,
        meta: { title: 'New Creative', hidden: true }
      },
      {
        path: ':id',
        name: 'creatives-edit',
        component: AdnetworksPage,
        meta: { title: 'Edit Creative', hidden: true }
      }
    ]
  },
  {
    path: '/advertising/rotation/modal/:modal/:cid/:typeId/:stream/:topic/:count/:sizeId?',
    redirect: (to) =>
      `/advertising/rotation/spots/${routeParam(to.params.cid)}`,
    meta: { hidden: true }
  },
  {
    path: '/advertising/link-network',
    component: Layout,
    children: [
      {
        path: '',
        name: 'link-network',
        component: AdnetworksOnboardingPage,
        meta: { title: 'Link Ad network', hidden: true }
      },
      {
        path: 'ask',
        name: 'link-network-ask',
        component: AdnetworksOnboardingPage,
        meta: { title: 'Request a new ad network', hidden: true }
      },
      {
        path: ':sourceId/link',
        name: 'link-network-link',
        component: AdnetworksOnboardingPage,
        meta: { title: 'Link the network', hidden: true }
      },
      {
        path: ':sourceId/import',
        name: 'link-network-import',
        component: AdnetworksOnboardingPage,
        meta: { title: 'Import zones', hidden: true }
      },
      {
        path: ':sourceId/import/load',
        name: 'link-network-import-load',
        component: AdnetworksOnboardingPage,
        meta: { title: 'Import zones', hidden: true }
      }
    ]
  }
]

export default rotationRoutes
